<!--
  //app/components/Shared/icons/InjuredPlayerIcon.vue
  -->
<script setup lang="ts">
type Props = {
  width?: number | string;
  height?: number | string;
};

withDefaults(defineProps<Props>(), {
  height: 25,
  width: 25,
});
</script>

<template>
  <div
    class="flex items-center justify-center bg-white rounded-full p-0.5 text-red-700 font-black text-3xl leading-[0]"
  >
    <svg
      fill="currentColor"
      :height="height"
      :width="width"
      viewBox="0 -960 960 960"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="m416-416h-222v-128h222v-223h128v223h222v128h-222v222h-128z"
        stroke="currentColor"
        stroke-width="55"
      />
    </svg>
  </div>
</template>

<style scoped></style>
